import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import classNames from 'classnames';

import ApiConstants from 'PMT/constants/ApiConstants';
import I18n from 'PMT/i18n/I18n';

import OrderAction from 'actions/OrderAction';

import { CurrencyUtils, OrderViewUtils } from 'PMT/utils';

// -- entities
import Order from 'PMT/entities/order/Order';

// -- utils
import PhoneUtils from 'PMT/utils/PhoneUtils';

// -- views
import SvgIcon from 'PMT/components/SvgIcon';
import { OrderStatusLabel } from 'components/order';

import { ModalType } from '../constants'

/**
 * @parents OrdersReadyView, OrdersNotReadyView
 */
class OrderRowView extends Component {

  static propTypes = {
    order: PropTypes.objectOf(Order),

    selected: PropTypes.bool.isRequired,

    /**
     * parameter: Order
     */
    onSelected: PropTypes.func.isRequired,

    priority: PropTypes.string,

    currencyCode: PropTypes.string,

  };

  // timeInterval = null;
  //
  // componentDidMount() {
  //   this.initCountdownTimer();
  // }
  //
  // componentDidUpdate() {
  //   this.initCountdownTimer();
  // }
  //
  // componentWillUnmount() {
  //   clearInterval(this.timeInterval);
  // }
  //
  // initCountdownTimer() {
  //   clearInterval(this.timeInterval);
  //
  //   const clock = this.refs.countdown;
  //   console.log('clock', clock);
  //   this.timeInterval = setInterval(() => {
  //     clock.innerHTML = `${.format()}
  //   }, 1000);
  // }

  onSelect = modalType => {
    this.props.onSelected(this.props.order, modalType);
  }

  onHistorizeOrder = (event) => {
    event.stopPropagation();

    const order: Order = this.props.order;

    order.status = Order.OrderStatus.DELIVERED;
    OrderAction.updateOrder(order);
  };

  //
  //
  //

  render() {
    const order:Order = this.props.order;
    const currencyCode: string = this.props.currencyCode;

    const className = classNames('order_row_view', 'pointer',
    `PRIORITY_${this.props.priority}`, {
      selected: this.props.selected
    });

    return (
      <tr className={className} onClick={() => this.onSelect(ModalType.DETAIL)}>
        <td>#{order.getOrderNumber()}</td>
        <td
          className="text-left pickup_date_countdown"
          ref="countdown"
        >
          {order.getRemainingTimeLabel()}
        </td>
        {/* TODO : use new source method
        <td>{OrderViewUtils.getLabelForPlatform(order.source.platform)}</td>
        */}
        <td>
          {!order.isOnBar() &&
            <SvgIcon
              icon={OrderViewUtils.getIconForMode(order.mode)}
              style={styles.icon}
            />
          }
          {order.isOnBar() &&
            <SvgIcon
              icon={SvgIcon.ORDER_AT_BAR}
              style={styles.icon}
            />
          }
        </td>
        <td>
          {!_.isNull(order.user) &&
            `${order.user.firstName || ''} ${order.user.lastName || ''}`
          }
        </td>
        <td className="hidden-xs hidden-sm hidden-md">
          {!_.isNull(order.user) &&
            PhoneUtils.format(order.user.phone)
          }
        </td>
        <td>
          {order.isPayed() ?
            (
              <span>
                {CurrencyUtils.formatPriceWithCurrency(order.check.total,
                    currencyCode)}
              </span>
            ) : (
              <span>
                {CurrencyUtils.formatPriceWithCurrency(order.getTotalPrice(),
                    currencyCode)}
              </span>
            )
          }
        </td>
        <td className="text-center">
          {!order.isPayed() ?
            (
              <span>
                {I18n.tr('order.on_going.on_site')}
              </span>
            ) : (
              <span>
                <i className="pmt pmt-check" />
              </span>
            )
          }
        </td>
        <td className="text-right">
          {order.isCancelable() ? (
            <button
              type="button"
              className="btn btn-sm btn-link btn-cancel"
              onClick={e => {
                e.stopPropagation()
                e.preventDefault()
                this.onSelect(ModalType.CANCEL)
              }}
            >
              {I18n.tr('order.on_going.cancel')}
            </button>
          ) : (
            <span className="btn btn-sm text-muted disabled">
              {I18n.tr('order.on_going.not_cancelable')}
            </span>
          )}
        </td>
        <td className="text-right">
          {/* TODO: isReceived could produce a bug if the status is set between received and DELIVERED (READY, IN_DELIVERY) */}
          {this.props.priority !== Order.Priority.LATER && order.isReceived() &&
            <button
              className="btn btn-sm btn-default"
              onClick={this.onHistorizeOrder}
            >
              {I18n.tr('order.on_going.order_ready')}
            </button>
          }
        </td>
      </tr>
    );
  }

}

const styles = {
  icon: {
    height: '25px',
    width: 'auto'
  }
}

export default OrderRowView;



// WEBPACK FOOTER //
// ./scripts/pages/order/ordersList/ordersOnGoing/OrderRowView.js